<div *ngIf="contract_info && contract_info.contract_code" class="ms-4" style="padding-top: 70px;">
    <h3 style="font-weight: bold;color: #544f4f;">Contract ID: {{contract_info.contract_code}}</h3>
    <button class="btn btn-outline-secondary" *ngIf="mode == 1" (click)="downloadContract()">
        Download Contract
    </button>
    <button class="btn btn-outline-secondary" *ngIf="mode != 1" (click)="downloadConsent()">
        Download Consent Form
    </button>
</div>
<div *ngIf="error && !(contract_info && contract_info.contract_code)" class="ms-5" style="padding-top: 70px;">
    {{error}}
</div>